/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateDeliverableInput = {
    name?: string | null | undefined;
    description?: string | null | undefined;
    projectId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type CreateDeliverableMutationVariables = {
    input: CreateDeliverableInput;
};
export type CreateDeliverableMutationResponse = {
    readonly createDeliverable: {
        readonly deliverable: {
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly description: string | null;
            } | null;
        } | null;
    } | null;
};
export type CreateDeliverableMutation = {
    readonly response: CreateDeliverableMutationResponse;
    readonly variables: CreateDeliverableMutationVariables;
};



/*
mutation CreateDeliverableMutation(
  $input: CreateDeliverableInput!
) {
  createDeliverable(input: $input) {
    deliverable {
      node {
        id
        name
        description
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateDeliverableInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateDeliverablePayload",
    "kind": "LinkedField",
    "name": "createDeliverable",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DeliverableTypeEdge",
        "kind": "LinkedField",
        "name": "deliverable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DeliverableType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateDeliverableMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateDeliverableMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateDeliverableMutation",
    "operationKind": "mutation",
    "text": "mutation CreateDeliverableMutation(\n  $input: CreateDeliverableInput!\n) {\n  createDeliverable(input: $input) {\n    deliverable {\n      node {\n        id\n        name\n        description\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b4f62cf463f8fbb8db0d2123a1a043dd';
export default node;
